// https://en.wikipedia.org/wiki/IETF_language_tag
// https://www.venea.net/web/culture_code

export enum LanguageCode {
  Swedish = 'sv-SE',
  Finnish = 'fi-FI',
  Danish = 'da-DK',
  English = 'en-GB',
  Spanish = 'es-ES',
  German = 'de-DE',
  French = 'fr-FR',
  Norwegian = 'nb-NO',
}
